module.exports = __webpack_public_path__ + "16a7a07552d46eed155219bf7a80cbbe.svg";